import { makeStyles } from "@mui/styles";

const useListStyles = makeStyles((theme) => ({
    form_title: {
        color: theme.palette.primary.main,
        display: "flex",
        alignItems: "center",
        marginBottom: "1rem",
    },
    modal_title: {
        color: "black",
        display: "flex",
        alignItems: "center",
        marginBottom: "1rem",
    },
    container: {
        width: "100%"
    },
    modalContent: {
        width: "400px",
        height: "100%",
        overflowY: "auto",
        backgroundColor: "white",
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2),
        position: "fixed",
        right: 0,
        transform: "translateY(-50%)",
        outline: "none",
    },
    innerBox: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "0.5px solid",
        borderColor: theme.palette.grey.main,
        width: "50%",
        marginBottom: "3rem",
        paddingBottom: "1rem",
    },
    outerBox: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        minHeight: "100%",
    },
    deleteButton: {
        margin: "1rem",
        color: theme.palette.error.main,
    },
}));

export default useListStyles;
